// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class PetOrderAPI extends MainAPI {
	/**
	* @params {Object} purchaseDetails
	* */
	async getPetPurchase(purchaseDetails) {
		return API.get(`${ENDPOINTS.GET_PET_ORDERS}/orders?${queryString.stringify(purchaseDetails)}`);
	}

	/**
	* @params {Object} purchaseDetails
	* @params {id} orderId
	* */
	async putPetPurchase(purchaseDetails,orderId) {
		return API.put(`${ENDPOINTS.PUT_PET_ORDERS}/${orderId}/orders`,purchaseDetails);
	}

	/**
	* @params {id} orderId
	* */
	async getPetPurchaseByOrderId(orderId) {
		return API.get(`${ENDPOINTS.GET_PET_ORDERS}/${orderId}/orders`);
	}
	/**
	* @params none
	* */
	async getPetOrderCount() {
		return API.get(`${ENDPOINTS.GET_PET_ORDERS}/count`);
	}

	/**
	* @params {Object} referenceId
	* */
	async getDogPurchase(referenceId) {
		return API.get(`${ENDPOINTS.GET_DOG_PURCHASE}?${queryString.stringify(referenceId)}`);
	}

	/**
	* @params {Object} details
	* */
	async dogPurchaseApprovedDisapproved(details) {
		return API.put(`${ENDPOINTS.PUT_DOG_PURCHASE}/approved-disapproved`, details);
	}

	/**
	* @params {Object} details
	* */
	async updateDogPurchaseDetails(details,referenceId) {
		return API.put(`${ENDPOINTS.PUT_DOG_PURCHASE}/${referenceId}/update`, details);
	}

	/**
	* @params {Object} requestDetails
	* */
	async dogPurchaseApprovedDisapprovedRefund(requestDetails) {
		return API.put(`${ENDPOINTS.PUT_DOG_PURCHASE}/approved-disapproved-refund`, requestDetails);
	}

	/**
	* @params {Object} requestDetails
	* */
	async dogPurchaseApprovedRefund(requestDetails) {
		console.log(requestDetails);
		return API.put(`${ENDPOINTS.PUT_DOG_PURCHASE}/approved-refund-interest-free`, requestDetails);
	}

	async dogPurchaseApprovedDisapprovedBreed(requestDetails) {
		return API.put(`${ENDPOINTS.PUT_DOG_PURCHASE}/new-breed/approved-disapproved`, requestDetails);
	}
}

export default new PetOrderAPI();
